import { Component, inject, OnInit } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { CommonModule, NgClass } from '@angular/common';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { primeNgTranslation } from './core/constants/primeNgTranslation';
import { ModalDetallesTransaccionComponent } from './modules/formas-pago/components/modal-detalles-transaccion/modal-detalles-transaccion.component';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { LoadingService } from './core/services/loading.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { PopUpComponent } from './shared/components/pop-up/pop-up.component';
import { TourComponent } from './shared/components/tour/tour.component';
import { initialize } from '@capacitor-community/safe-area';
import { IdleService } from './core/services/idle.service';
import { AuthService } from './modules/auth/auth.service';
import { SessionModalComponent } from './shared/components/session-modal/session-modal.component';
import { globalConfig } from './core/utils/globalConfig';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TourComponent,
    NgClass,
    RouterOutlet,
    ToastModule,
    ModalDetallesTransaccionComponent,
    LoadingComponent,
    PopUpComponent,
    SessionModalComponent,
  ],
  providers: [MessageService],
})
export class AppComponent implements OnInit {
  loadingService = inject(LoadingService);
  router = inject(Router);

  title = 'Tolis';
  loading = true;
  showModal = false;
  countdown = 0;

  constructor(
    public themeService: ThemeService,
    private primengConfig: PrimeNGConfig,
    private authService: AuthService,
    private idleService: IdleService,
  ) {}

  async ngOnInit() {
    this.primengConfig.ripple = true;
    this.primengConfig.zIndex = {
      modal: 1100, // dialog, sidebar
      overlay: 1200, // dropdown, overlaypanel
      menu: 1200, // overlay menus
      tooltip: 1100, // tooltip
    };
    this.primengConfig.setTranslation(primeNgTranslation);

    this.loadingService.loading$.subscribe((loading) => {
      this.loading = loading;
    });

    if (sessionStorage.getItem(globalConfig.tokenApi)) {
      this.idleService.startWatching();
    } else {
      this.idleService.stopWatching();
    }

    this.idleService.onTimeoutWarning$.subscribe((countdown) => {
      this.countdown = countdown;
      this.showModal = true;
    });

    this.idleService.onTimeout$.subscribe(() => {
      this.showModal = false;
      this.authService.logout();
    });

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loadingService.hide();
      }
    });

    initialize();

    try {
      await SplashScreen.hide();
    } catch (err) {
      console.error('Error with splash screen:', err);
    }
  }

  onStayActive() {
    this.idleService.resetTimer(); // ✅ Reanuda
    this.showModal = false;
  }
}
